import { ToLineItemBlockTransformation } from '../ToLineItemBlockTransformation';
import { ParseResult } from '../../ParseResult';
import { Word } from '../../Word';
import { MODIFIED_ANNOTATION, UNCHANGED_ANNOTATION } from '../../Annotation';
import { BlockType } from '../../markdown/BlockType';

const SPACES_PER_INDENT_LEVEL = 3;

// Cares for proper sub-item spacing/leveling
export class DetectListLevels extends ToLineItemBlockTransformation {
  constructor() {
    super('Level Lists');
    this.showWhitespaces = true;
  }

  override transform(parseResult: ParseResult): ParseResult {
    let listBlocks = 0;
    let modifiedBlocks = 0;
    parseResult.pages.forEach((page) => {
      page.items.filter((block: any) => block.type === BlockType.LIST).forEach((listBlock: any) => {
        let lastItemX: number | undefined;
        let currentLevel = 0;
        const xByLevel: Record<number, number> = {};
        let modifiedBlock = false;
        listBlock.items.forEach((item: any) => {
          const isListItem = true;
          if (lastItemX !== undefined && isListItem) {
            if (item.x > lastItemX) {
              currentLevel++;
              xByLevel[item.x] = currentLevel;
            } else if (item.x < lastItemX) {
              currentLevel = xByLevel[item.x] || 0;
            }
          } else {
            xByLevel[item.x] = 0;
          }
          if (currentLevel > 0) {
            item.words = [new Word({ string: ' '.repeat(currentLevel * SPACES_PER_INDENT_LEVEL) })].concat(item.words);
            modifiedBlock = true;
          }
          lastItemX = item.x;
        });
        listBlocks++;
        if (modifiedBlock) {
          modifiedBlocks++;
          listBlock.annotation = MODIFIED_ANNOTATION;
        } else {
          listBlock.annotation = UNCHANGED_ANNOTATION;
        }
      });
    });
    return new ParseResult({
      ...parseResult,
      messages: ['Modified ' + modifiedBlocks + ' / ' + listBlocks + ' list blocks.'],
    });
  }
}
